import React from 'react'

export default function ThankyouPage() {
    return (
        <div className="tab-inner-section">
            <div className="trans-header">
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading d-flex justify-content-between align-items-center">
                                <div className="left-wrap">
                                    <div className="ques-options">
                                        <h5>Particulars</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="tab-inner-heading">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="left-wrap d-flex">
                                                <div className="drop-wrap ques-options">
                                                    <h5>ENG</h5>
                                                    <p>Default</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="tab-inner-heading">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="left-wrap d-flex">
                                                <div className="drop-wrap">
                                                    <div className="dropdown table-dropdown ques-options">
                                                        <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                            aria-haspopup="true" aria-expanded="false">
                                                            <span className='me-2'>SPA</span>
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="languages">
                                                            <a className="dropdown-item" href="#">
                                                                English
                                                            </a>
                                                            <a className="dropdown-item" href="#">
                                                                German
                                                            </a>
                                                            <a className="dropdown-item" href="#">
                                                                Spanish
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <p>Spanish</p>
                                                </div>
                                            </div>
                                            <div className="right-action-btn">
                                                <button type="button" className="btn btn-bordered">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="trans-wrap">
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="questions-wrapper">
                                <div className="translation-list">
                                    <div className="translate"><p>Thank you message</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate d-flex align-items-center">
                                                <div className="Sortingcheck">
                                                    <input type="checkbox" className="form-check-input" id="language-check1" />
                                                </div>
                                                <div className='chiceFields choiceInput flex-grow-1'>
                                                    <div className="translate">
                                                        {/* <p>Thank you </p> */}
                                                        <textarea className="choiceItext single-line" cols={1} defaultValue={"Thank you "} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate">
                                                <textarea className="choiceItext single-line" cols={1} defaultValue={"Gracias"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex lead-gen-wrapper">
                    <div className="lead-gen-left">
                        <div className="tab-inner-wrapper">
                            <div className="questions-wrapper">
                                <div className="translation-list">
                                    <div className="translate"><p>Sub text</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1 lead-gen-main">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate d-flex align-items-center checked">
                                                <div className="Sortingcheck">
                                                    <input type="checkbox" className="form-check-input" id="language-check1" defaultChecked />
                                                </div>
                                                <div className='chiceFields choiceInput flex-grow-1'>
                                                    <div className="translate">
                                                        {/* <p>Here are your personalized  recommendations</p> */}
                                                        <textarea className="choiceItext single-line" cols={1} defaultValue={"Here are your personalized  recommendations"} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="tab-inner-wrapper right-tab">
                                    <div className="questions-wrapper">
                                        <div className="translation-list">
                                            <div className="translate">
                                                <textarea className="choiceItext single-line" cols={1} defaultValue={"Aquí tienes tus recomendaciones personalizadas"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
